var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSemiTruck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_526",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29238",
    "data-name": "Group 29238",
    transform: "translate(64 10673)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -64, -10673)",
    filter: "url(#Ellipse_526)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_526-2",
    "data-name": "Ellipse 526",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50419",
    "data-name": "Path 50419",
    d: "M330.6,25.88c-.323.568-.6,1.056-.754,1.365a.374.374,0,0,1-.137.144.324.324,0,0,1-.438-.137c-.158-.309-.438-.8-.754-1.372C327.3,23.7,325.4,20.311,325.4,18.968a4.168,4.168,0,0,1,8.335,0C333.728,20.311,331.824,23.7,330.6,25.88Z",
    transform: "translate(-345.687 -10669.8)",
    fill: "#ef5350",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50420",
    "data-name": "Path 50420",
    d: "M342.462,28.7a3.16,3.16,0,0,1,2.235,5.4,3.181,3.181,0,0,1-2.235.927,3.138,3.138,0,0,1-2.235-.927,3.18,3.18,0,0,1-.927-2.235,3.165,3.165,0,0,1,3.162-3.162Z",
    transform: "translate(-358.588 -10682.701)",
    fill: "#c24441",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50421",
    "data-name": "Path 50421",
    d: "M352.854,38.733a2.481,2.481,0,1,0,.733,1.768A2.505,2.505,0,0,0,352.854,38.733Z",
    transform: "translate(-367.22 -10691.333)",
    fill: "#f5f5f5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50422",
    "data-name": "Path 50422",
    d: "M160.675,58.23c-.187.323-.338.6-.431.783a.142.142,0,0,1-.079.079.183.183,0,0,1-.251-.079c-.093-.172-.251-.453-.431-.783-.7-1.243-1.782-3.183-1.782-3.952a2.378,2.378,0,0,1,4.757,0C162.457,55.047,161.372,56.987,160.675,58.23Z",
    transform: "translate(-190.037 -10704.234)",
    fill: "#ef5350",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50423",
    "data-name": "Path 50423",
    d: "M167.411,59.8a1.791,1.791,0,0,1,1.279.532,1.821,1.821,0,0,1,.532,1.279,1.811,1.811,0,1,1-3.09-1.279A1.821,1.821,0,0,1,167.411,59.8Z",
    transform: "translate(-197.369 -10711.566)",
    fill: "#c24441",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50424",
    "data-name": "Path 50424",
    d: "M173.429,65.617a1.422,1.422,0,1,0,.417,1.006A1.424,1.424,0,0,0,173.429,65.617Z",
    transform: "translate(-202.381 -10716.578)",
    fill: "#f5f5f5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50425",
    "data-name": "Path 50425",
    d: "M12.936,31.439c-.223.4-.417.74-.525.956a.254.254,0,0,1-.093.1.233.233,0,0,1-.309-.093c-.115-.216-.3-.553-.525-.956C10.622,29.923,9.3,27.551,9.3,26.61a2.87,2.87,0,0,1,.855-2.055A2.925,2.925,0,0,1,12.21,23.7a2.883,2.883,0,0,1,2.055.855,2.913,2.913,0,0,1,.855,2.055C15.113,27.551,13.791,29.923,12.936,31.439Z",
    transform: "translate(-52.3 -10678.061)",
    fill: "#ef5350",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50426",
    "data-name": "Path 50426",
    d: "M21.213,33.4a2.208,2.208,0,1,1-1.566.647A2.2,2.2,0,0,1,21.213,33.4Z",
    transform: "translate(-61.303 -10687.063)",
    fill: "#c24441",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50427",
    "data-name": "Path 50427",
    d: "M28.568,40.51a1.739,1.739,0,1,0,0,2.457,1.735,1.735,0,0,0,0-2.457Z",
    transform: "translate(-67.429 -10693.189)",
    fill: "#f5f5f5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50428",
    "data-name": "Path 50428",
    d: "M288.638,234.785a.337.337,0,0,1-.338-.338v-12.51a.337.337,0,0,1,.338-.338h7.609a.335.335,0,0,1,.316.223l2.515,6.208a.406.406,0,0,1,.022.129v1.322h-.8a.711.711,0,0,0,0,1.423h.8v3.55a.337.337,0,0,1-.338.338Q293.7,234.782,288.638,234.785Z",
    transform: "translate(-311.253 -10861.74)",
    fill: "#ef5350"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50429",
    "data-name": "Path 50429",
    d: "M324.339,358.321h-6.524a2.6,2.6,0,0,1-.014-.338,3.284,3.284,0,0,1,6.567,0C324.353,358.1,324.353,358.214,324.339,358.321Z",
    transform: "translate(-338.633 -10985.276)",
    fill: "#9e3735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50430",
    "data-name": "Path 50430",
    d: "M332.388,367.139h-5.166a2.6,2.6,0,1,1,5.181-.338A1.748,1.748,0,0,1,332.388,367.139Z",
    transform: "translate(-347.358 -10994.094)",
    fill: "#ef5350"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50431",
    "data-name": "Path 50431",
    d: "M316.345,249.5h4.261a.335.335,0,0,1,.316.223l1.861,4.6a.336.336,0,0,1-.187.438.407.407,0,0,1-.129.022h-6.129a.337.337,0,0,1-.338-.338v-4.613A.342.342,0,0,1,316.345,249.5Zm1.207,5.964a.338.338,0,0,1,0,.675h-1.207a.338.338,0,0,1,0-.675Z",
    transform: "translate(-336.962 -10887.636)",
    fill: "#9e3735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50432",
    "data-name": "Path 50432",
    d: "M13.7,171.938a.337.337,0,0,1,.338-.338H33.769a.337.337,0,0,1,.338.338v16.1a.337.337,0,0,1-.338.338H14.038a.337.337,0,0,1-.338-.338Z",
    transform: "translate(-56.384 -10815.333)",
    fill: "#729bc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50433",
    "data-name": "Path 50433",
    d: "M29.407,332.7H22.883a2.6,2.6,0,0,1-.014-.338,3.284,3.284,0,0,1,6.567,0C29.422,332.482,29.414,332.6,29.407,332.7Zm-6.79,0H16.093a2.6,2.6,0,0,1-.014-.338,3.284,3.284,0,0,1,6.567,0C22.631,332.482,22.624,332.6,22.617,332.7ZM13.7,327.1H34.1v1.667H13.7Z",
    transform: "translate(-56.384 -10959.66)",
    fill: "#4c6682"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50434",
    "data-name": "Path 50434",
    d: "M76.341,364.962a2.6,2.6,0,1,1-.762,1.839A2.584,2.584,0,0,1,76.341,364.962Zm-12.689,0a2.6,2.6,0,1,1-.762,1.839A2.627,2.627,0,0,1,63.652,364.962Zm-6.79,0A2.6,2.6,0,1,1,56.1,366.8,2.627,2.627,0,0,1,56.862,364.962Z",
    transform: "translate(-95.737 -10994.095)",
    fill: "#2e343a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50435",
    "data-name": "Path 50435",
    d: "M70.96,377.3a1.632,1.632,0,0,0-1.171.489,1.692,1.692,0,0,0-.489,1.178,1.661,1.661,0,1,0,1.66-1.667Z",
    transform: "translate(-107.989 -11006.253)",
    fill: "#a2abb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50436",
    "data-name": "Path 50436",
    d: "M81.237,389.244a.819.819,0,0,1,1.4.582.838.838,0,0,1-.237.582.8.8,0,0,1-.582.244.828.828,0,0,1-.582-1.408Z",
    transform: "translate(-118.848 -11017.112)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50437",
    "data-name": "Path 50437",
    d: "M329.2,258.8h-3.7v3.945h5.288Z",
    transform: "translate(-345.78 -10896.268)",
    fill: "#bfddff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50438",
    "data-name": "Path 50438",
    d: "M335.559,258.8h-.489l-2.271,3.945h.481Zm-1.279,3.945h.489l1.645-2.853-.2-.5Z",
    transform: "translate(-352.555 -10896.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50439",
    "data-name": "Path 50439",
    d: "M410.384,322v.675h-.8a.711.711,0,1,0,0,1.423h.8v.675h-.8a1.38,1.38,0,1,1,0-2.759Z",
    transform: "translate(-422.537 -10954.927)",
    fill: "#9e3735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50440",
    "data-name": "Path 50440",
    d: "M419.016,331.207v1.415h-.8a.711.711,0,1,1,0-1.423Z",
    transform: "translate(-431.169 -10963.465)",
    fill: "#ffe26f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50441",
    "data-name": "Path 50441",
    d: "M165.367,377.3a1.668,1.668,0,1,0,1.178.489A1.662,1.662,0,0,0,165.367,377.3Z",
    transform: "translate(-195.606 -11006.253)",
    fill: "#a2abb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50442",
    "data-name": "Path 50442",
    d: "M175.644,389.244a.815.815,0,1,1-.244.582A.814.814,0,0,1,175.644,389.244Z",
    transform: "translate(-206.465 -11017.112)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50443",
    "data-name": "Path 50443",
    d: "M341.867,377.3a1.668,1.668,0,1,0,1.178.489A1.662,1.662,0,0,0,341.867,377.3Z",
    transform: "translate(-359.423 -11006.253)",
    fill: "#a2abb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50444",
    "data-name": "Path 50444",
    d: "M352.244,389.244a.815.815,0,1,1-.244.582A.814.814,0,0,1,352.244,389.244Z",
    transform: "translate(-370.376 -11017.112)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50445",
    "data-name": "Path 50445",
    d: "M68.928,186.4H79.483a1.03,1.03,0,0,1,1.028,1.028v7a1.03,1.03,0,0,1-1.028,1.028H68.928a1.03,1.03,0,0,1-1.028-1.028v-7a1.03,1.03,0,0,1,1.028-1.028Z",
    transform: "translate(-106.689 -10829.069)",
    fill: "#ffd47d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50446",
    "data-name": "Path 50446",
    d: "M102.2,186.4h2.364v4.7a.216.216,0,0,1-.216.216.2.2,0,0,1-.18-.1l-.79-1.013-.8,1.028a.216.216,0,0,1-.3.036.2.2,0,0,1-.079-.165Zm5.324,0h2.364v4.7a.216.216,0,0,1-.216.216.2.2,0,0,1-.18-.1l-.79-1.013-.8,1.028a.216.216,0,0,1-.3.036.2.2,0,0,1-.079-.165Z",
    transform: "translate(-138.525 -10829.069)",
    fill: "#edaf54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50447",
    "data-name": "Path 50447",
    d: "M87.816,263.5H89.4a.216.216,0,0,1,.216.216v2.026a.216.216,0,0,1-.216.216H87.816a.216.216,0,0,1-.216-.216v-2.026A.226.226,0,0,1,87.816,263.5Zm2.917,0h1.581a.216.216,0,0,1,.216.216v2.026a.216.216,0,0,1-.216.216H90.733a.216.216,0,0,1-.216-.216v-2.026A.226.226,0,0,1,90.733,263.5Z",
    transform: "translate(-124.974 -10900.63)",
    fill: "#d78e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50448",
    "data-name": "Path 50448",
    d: "M169.016,263.931a.216.216,0,0,1-.216-.216.212.212,0,0,1,.216-.216h3.514a.216.216,0,0,1,.216.216.212.212,0,0,1-.216.216Zm0,1.013a.216.216,0,0,1,0-.431h3.514a.216.216,0,1,1,0,.431Zm0,1.013a.216.216,0,0,1,0-.431h3.514a.216.216,0,1,1,0,.431Z",
    transform: "translate(-200.339 -10900.63)",
    fill: "#edaf54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50449",
    "data-name": "Path 50449",
    d: "M103.684,16.223a.344.344,0,1,1-.553.41,2.969,2.969,0,0,0-.632-.639,2.472,2.472,0,0,0-2.989,0,2.968,2.968,0,0,0-.632.639.344.344,0,1,1-.553-.41,3.821,3.821,0,0,1,.776-.783A3.144,3.144,0,0,1,101,14.8a3.191,3.191,0,0,1,1.9.639A3.4,3.4,0,0,1,103.684,16.223Zm5.037.539a.345.345,0,1,1,.144-.675c.014,0,4.031.819,4.613,5.835A.344.344,0,1,1,112.8,22C112.271,17.48,108.735,16.762,108.721,16.762Z",
    transform: "translate(-134.864 -10669.8)",
    fill: "#ef5350",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemiTruck);
export default __webpack_public_path__ + "static/media/semiTruck.596743d3df46675974c2d5624c9e31c1.svg";
export { ForwardRef as ReactComponent };